import { APIResponseAction, StaticPagesState } from 'types'

export const initialState = {
  discoverTabs: {},
}

const reducer = (state: StaticPagesState = initialState, action: APIResponseAction): StaticPagesState => {
  switch (action.type) {
    case 'FETCH_DISCOVER_SUBPAGES_DONE': {
      const {
        data: {
          response: {
            entities: { pageSummaries },
          },
        },
      } = action
      if (!pageSummaries) {
        return state
      }
      const tabs = Object.keys(pageSummaries).reduce((agg, key) => {
        const page = pageSummaries[key]
        const {
          meta: { slug },
          title,
          id,
          summary,
        } = page
        return { ...agg, [slug]: { slug, title, pageId: id, summary } }
      }, {})
      return {
        ...state,
        discoverTabs: tabs,
      }
    }
    default:
      return state
  }
}

export default reducer
